/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationnotextcontent3Inputs */

const en_moderationnotextcontent3 = /** @type {(inputs: Moderationnotextcontent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No text content`)
};

const de_moderationnotextcontent3 = /** @type {(inputs: Moderationnotextcontent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Textinhalt`)
};

/**
* | output |
* | --- |
* | "No text content" |
*
* @param {Moderationnotextcontent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationnotextcontent3 = /** @type {((inputs?: Moderationnotextcontent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationnotextcontent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationnotextcontent3(inputs)
	return de_moderationnotextcontent3(inputs)
});
export { moderationnotextcontent3 as "moderationNoTextContent" }